import { type FilterActionEvent, filterActionEventSchema } from './interactiveTrackingEventSchema';
import logger from '../logger';

export type FilterActionEventProps = Omit<FilterActionEvent, 'event' | 'event_name' | 'page_url'>;

export const buildFilterActionEvent = (props: FilterActionEventProps): FilterActionEvent => {
  const {
    filter_category,
    filter_element,
    filter_interaction,
    filter_value,
    page_type,
    click_url
  } = props;

  const filterActionEvent: FilterActionEvent = {
    event: 'ga4_event',
    event_name: 'filter_action',
    page_url: globalThis.window.location.href,
    page_type,
    filter_category,
    filter_element,
    filter_interaction,
    filter_value,
    click_url: click_url ?? ''
  };

  const result = filterActionEventSchema.safeParse(filterActionEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid filter action event');
  }

  return filterActionEvent;
};
